import { action, makeObservable, observable, reaction } from 'mobx';
import { userInfoStore } from '../../../store/userInfoStore';
import { freeBetStore } from '../../../store/freeBetStore';

class FishingBetsStore {
  isBetsClosed = false;

  cashOutWin = null;

  isBetAccepted = false;

  roundId = null;

  openedFishes = [];

  winAmount = null;

  winOdd = null;

  odd = null;

  fishOdd = null;

  userBet = null;

  isAllowCashOut = false;

  roundDuration = null;

  time = null;

  durationFromResultReport = null;

  isRoundStart = false;

  constructor() {
    makeObservable(this, {
      time: observable,
      winOdd: observable,
      fishOdd: observable,
      odd: observable,
      roundId: observable,
      userBet: observable,
      winAmount: observable,
      cashOutWin: observable,
      isBetsClosed: observable,
      isRoundStart: observable,
      roundDuration: observable,
      isBetAccepted: observable,
      isAllowCashOut: observable,
      durationFromResultReport: observable,
      openedFishes: observable.deep,
      setTime: action.bound,
      setWinOdd: action.bound,
      setFishOdd: action.bound,
      setOdd: action.bound,
      setRoundId: action.bound,
      setWinAmount: action.bound,
      setCashOutWin: action.bound,
      setOpenedFishes: action.bound,
      setIsBetsClosed: action.bound,
      setRoundDuration: action.bound,
      setIsBetAccepted: action.bound,
      setIsAllowCashOut: action.bound,
      updateOpenedFishes: action.bound,
    });
    reaction(
      () => this.roundId,
      (value, prev) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        if (value && prev && value !== prev) {
          setIsAllowedChangeCurrency(!this.roundId);
        }
      }
    );
    reaction(
      () => this.isBetAccepted,
      (value) => {
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  setIsRoundStart(bool) {
    this.isRoundStart = bool;
  }

  setTime(time) {
    this.time = time;
  }

  setFishOdd(odd) {
    this.fishOdd = odd;
  }

  setOdd(odd) {
    this.odd = odd;
  }

  setRoundDuration(second) {
    this.roundDuration = second;
    this.durationFromResultReport = Math.floor(second / 2) + 1;
  }

  setIsAllowCashOut(bool) {
    this.isAllowCashOut = bool;
  }

  setUserBet(bet) {
    this.userBet = bet;
  }

  setWinOdd(odd) {
    this.winOdd = odd;
  }

  setWinAmount(amount) {
    this.winAmount = amount;
  }

  setOpenedFishes(openedFishes) {
    this.openedFishes = openedFishes;
  }

  updateOpenedFishes(openedFish) {
    this.openedFishes = [openedFish, ...this.openedFishes];
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  setRoundId(id) {
    this.roundId = id;
  }

  setCashOutWin(amount) {
    this.cashOutWin = amount;
  }

  setIsBetAccepted(bool) {
    this.isBetAccepted = bool;
  }

  resetStore() {
    this.isBetsClosed = false;
    this.cashOutWin = null;
    this.isBetAccepted = false;
    this.roundId = null;
    this.openedFishes = [];
    this.winAmount = null;
    this.winOdd = null;
    this.userBet = null;
    this.isAllowCashOut = false;
    this.roundDuration = null;
    this.time = null;
    this.durationFromResultReport = null;
    this.isRoundStart = false;
  }
}

export const fishingBetsStore = new FishingBetsStore();
